const INGREDIENT_SPECIAL_CASE_TYPE_LABELS = {
  PARSING_RULE: 'Parsing Rule',
  IGNORED_COMBINATION: 'Ignored Combination',
  DEFAULT_INGREDIENT: 'Default Ingredient',
}

export default INGREDIENT_SPECIAL_CASE_TYPE_LABELS
